import React, {createContext, useReducer, useMemo} from "react";

let FoliosContext = createContext();

let initialState = {
  openAgregarFolios: false,
  openObtenerFolios: false,
  foliosFiles: [],
  foliosXml: []
};

let fixedState = JSON.parse(JSON.stringify(initialState));

let reducer = (state, action) => {
  switch (action.type) {
    case "reset": {
        return fixedState;
    }
    case "toggleAgregarFolio": {
        return { ...state, openAgregarFolios: !state.openAgregarFolios };
    }
    case "agregarFolio": {
        var foliosFiles = state.foliosFiles;
        var foliosXml = state.foliosXml;
        foliosFiles.push(action.folio);
        foliosXml.push(action.folioXml);
        return { ...state, foliosFiles, foliosXml };
    }
    case "toggleObtenerFolio": {
      return { ...state, openObtenerFolios: !state.openObtenerFolios };
    }
    case "quitarFolio": {
      var foliosFiles = state.foliosFiles;
      var foliosXml = state.foliosXml;
      foliosFiles.splice(action.index, 1);
      foliosXml.splice(action.index, 1);
      return { ...state, foliosFiles, foliosXml };
    }
    default:
      return state;
  }
};

function FoliosProvider(props) {
  let [state, dispatch] = useReducer(reducer, initialState);
  let value = useMemo(() => ({ state, dispatch }), [state]);

  return (
    <FoliosContext.Provider value={value}>{props.children}</FoliosContext.Provider>
  );
}

let FoliosConsumer = FoliosContext.Consumer;

export { FoliosContext, FoliosProvider, FoliosConsumer };